import Schedule from '../shared/Schedule';

const AdminSchedule = () => {
  return <Schedule isAdmin={true} />;
};

export default AdminSchedule;
